import { render, staticRenderFns } from "./Peajes.vue?vue&type=template&id=016a275c&scoped=true&"
import script from "./Peajes.vue?vue&type=script&lang=ts&"
export * from "./Peajes.vue?vue&type=script&lang=ts&"
import style0 from "./Peajes.vue?vue&type=style&index=0&id=016a275c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a275c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('016a275c', component.options)
    } else {
      api.reload('016a275c', component.options)
    }
    module.hot.accept("./Peajes.vue?vue&type=template&id=016a275c&scoped=true&", function () {
      api.rerender('016a275c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Peajes/Mantencion/Peajes.vue"
export default component.exports